import React from 'react';
import { Box, CircularProgress, Alert, Button, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { IPD_COLORS } from '../../theme';

/**
 * `skeleton`, `emptyIcon`, `emptyTitle` and `emptyAction` are opt-in: without them
 * the spinner / plain-text states below stay exactly as the other tabs render them.
 */
export default function PharmacyTableState({
  loading,
  error,
  empty,
  emptyMessage,
  emptyIcon: EmptyIcon,
  emptyTitle,
  emptyAction,
  skeleton,
  onRetry,
  children,
}) {
  if (loading) {
    if (skeleton) return skeleton;
    return (
      <Box sx={{ py: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
        <CircularProgress size={32} sx={{ color: IPD_COLORS.primary }} />
        <Typography sx={{ fontSize: 13, color: IPD_COLORS.textSecondary }}>Loading…</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert
        severity="error"
        sx={{ borderRadius: '10px', my: 1 }}
        action={onRetry && (
          <Button color="inherit" size="small" startIcon={<RefreshIcon />} onClick={onRetry}>
            Retry
          </Button>
        )}
      >
        {error}
      </Alert>
    );
  }

  if (empty) {
    if (!EmptyIcon && !emptyTitle && !emptyAction) {
      return (
        <Typography sx={{ py: 3, textAlign: 'center', color: IPD_COLORS.textSecondary, fontSize: 14 }}>
          {emptyMessage || 'No records found.'}
        </Typography>
      );
    }
    return (
      <Box sx={{ py: 4, textAlign: 'center' }}>
        {EmptyIcon && <EmptyIcon sx={{ fontSize: 32, color: IPD_COLORS.textMuted }} />}
        {emptyTitle && (
          <Typography sx={{ fontSize: 14, fontWeight: 600, color: IPD_COLORS.textPrimary, mt: 1 }}>
            {emptyTitle}
          </Typography>
        )}
        <Typography sx={{ fontSize: 13, color: IPD_COLORS.textSecondary, mt: 0.5 }}>
          {emptyMessage || 'No records found.'}
        </Typography>
        {emptyAction && <Box sx={{ mt: 2 }}>{emptyAction}</Box>}
      </Box>
    );
  }

  return children;
}
